import { getVariation } from './artikel';

const isRestricted = (
  artikel: Artikel,
  konfig: ArtikelKonfiguration,
  variationWerte: ArtikelVariationWerte,
  kEigenschaftWert: number,
  restrictionType: RestrictionType
) => {
  const variation = artikel.variationen.find((v) => v.Werte?.find((w) => w.kEigenschaftWert === kEigenschaftWert));
  if (!variation) {
    throw new Error(`Keine Variation mit Wert kEigenschaftWert:${kEigenschaftWert} gefunden`);
  }
  const config = konfig.variations[variation.kEigenschaft];
  if (config) {
    const restrictions = config.restrictions
      .filter((r) => r.kEigenschaftWert === kEigenschaftWert)
      .filter((r) => r.type === restrictionType);
    for (let i = 0; i < restrictions.length; i += 1) {
      const res = restrictions[i];
      if (!res.combiner) {
        const value = variationWerte[res.kEigenschaft[0]];
        if (res.operator === 'greaterThan' && value > (res.value as number)) {
          return true;
        }
        if (res.operator === 'lessThan' && value < (res.value as number)) {
          return true;
        }
        if (res.operator === 'equals' && value === res.value) {
          return true;
        }
        if (res.operator === 'contains' && (res.value as number[]).includes(value)) {
          return true;
        }
        if (res.operator === 'lessThanDependentValue') {
          const dependentValue = res.value as DependentValue;
          const restricted = Object.keys(dependentValue)
            .reduce((prev, curr) => {
              const kEigenschaft = parseInt(curr, 10);
              const kEigenschaftWertRestriction = variationWerte[kEigenschaft];
              if (kEigenschaftWert === undefined) {
                throw new Error(`Für eine Restriction mit operator 'lessThanDependentValue' fehlt für kEigenschaft ${kEigenschaft} der Wert`);
              }
              const valueRestriction = dependentValue[kEigenschaft][kEigenschaftWertRestriction];
              return prev && value < valueRestriction;
            }, true);
          if (restricted) {
            return true;
          }
        }
        if (res.operator === 'greaterThanDependentValue') {
          const dependentValue = res.value as DependentValue;
          const restricted = Object.keys(dependentValue)
            .reduce((prev, curr) => {
              const kEigenschaft = parseInt(curr, 10);
              const kEigenschaftWertRestriction = variationWerte[kEigenschaft];
              if (kEigenschaftWert === undefined) {
                throw new Error(`Für eine Restriction mit operator 'lessThanDependentValue' fehlt für kEigenschaft ${kEigenschaft} der Wert`);
              }
              const valueRestriction = dependentValue[kEigenschaft][kEigenschaftWertRestriction];
              return prev && value > valueRestriction;
            }, true);
          if (restricted) {
            return true;
          }
        }
        if (res.operator !== 'greaterThan'
          && res.operator !== 'lessThan'
          && res.operator !== 'equals'
          && res.operator !== 'contains'
          && res.operator !== 'lessThanDependentValue'
          && res.operator !== 'greaterThanDependentValue') {
          throw new Error(`Der operator ${res.operator} ist aktuell nicht implementiert`);
        }
      } else if (res.combiner === 'multiply') {
        throw new Error(`Der combiner ${res.combiner} ist aktuell nicht implementiert`);
      } else {
        throw new Error(`Unbekannter combiner: ${res.combiner}`);
      }
    }
  }
  return false;
};

export const isDisabled = (
  artikel: Artikel,
  config: ArtikelKonfiguration,
  selectedVariationWerte: ArtikelVariationWerte,
  kEigenschaftWert: number
): boolean => isRestricted(artikel, config, selectedVariationWerte, kEigenschaftWert, 'disabled');

export const isHidden = (
  artikel: Artikel,
  config: ArtikelKonfiguration,
  selectedVariationWerte: ArtikelVariationWerte,
  kEigenschaftWert: number
): boolean => isRestricted(artikel, config, selectedVariationWerte, kEigenschaftWert, 'hidden');

export const isAllDisabled = (
  artikel: Artikel,
  config: ArtikelKonfiguration,
  selectedVariationWerte: ArtikelVariationWerte,
  kEigenschaft: number
): boolean => {
  const variation = getVariation(artikel, kEigenschaft);
  return !variation.Werte.some((wert) => !isDisabled(artikel, config, selectedVariationWerte, wert.kEigenschaftWert));
};

export const isAllHidden = (
  artikel: Artikel,
  config: ArtikelKonfiguration,
  selectedVariationWerte: ArtikelVariationWerte,
  kEigenschaft: number
): boolean => {
  const variation = getVariation(artikel, kEigenschaft);
  return !variation.Werte.some((wert) => !isHidden(artikel, config, selectedVariationWerte, wert.kEigenschaftWert));
};
